import React from "react";
import Button from "components/button";
import { Pencil } from "assets/icons";
import IconTooltip from "components/iconTooltip/IconTooltip";

/**
 * A summarised field: its value as saved, and the way back to the step that owns it.
 * `editLabel` names the pencil for screen readers, `editTooltip` is the short
 * text shown on hover (the label when not given).
 */
const SummaryField = ({ label, value, detail, editLabel, editTooltip, onEdit }) => (
    <div
        className={
            "flex justify-between items-center gap-4 py-3 border-b border-gray-100 last:border-b-0"
        }
    >
        <div className={"ft-sm text-gray-500 shrink-0"}>{label}</div>
        <div className={"flex items-center gap-3 min-w-0"}>
            <div className={"flex flex-col items-end min-w-0"}>
                <span className={"ft-sm text-gray-900 text-right break-words"}>
                    {value || "-"}
                </span>
                {detail ? (
                    <span
                        className={"ft-sm text-gray-500 text-right break-words"}
                    >
                        {detail}
                    </span>
                ) : null}
            </div>
            {/* shrink-0: beside a long value the button would otherwise be
                squeezed below its 36 px box. */}
            <IconTooltip label={editTooltip || editLabel}>
                <Button
                    color={"SECONDARY"}
                    size={"ICON"}
                    className={"shrink-0"}
                    onClick={onEdit}
                    ariaLabel={editLabel}
                >
                    <span aria-hidden="true">
                        <Pencil wh={16} color={"#374151"} />
                    </span>
                </Button>
            </IconTooltip>
        </div>
    </div>
);

export default SummaryField;
